import axios, { CancelToken } from 'axios';
import { CANCEL } from 'redux-saga';
import requestConfig from '../config/request';

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const getFromLocalStorage = key => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

function getRequestConfig(apiConfig) {
  let config = Object.assign({}, requestConfig);
  const token = getFromLocalStorage('token');
  const orgID = getFromLocalStorage('orgID');
  const ouId = getFromLocalStorage('ouId');
  const user = getFromLocalStorage('user');
  if (apiConfig) {
    config = Object.assign({}, requestConfig, apiConfig);
  }
  if (user && user.refID) {
    config.headers['X-CAP-REMOTE-USER'] = user.refID;
  }
  if (orgID !== undefined) {
    config.headers['X-CAP-API-AUTH-ORG-ID'] = orgID;
  }
  if (ouId !== undefined) {
    config.headers['x-cap-api-auth-ou-id'] = ouId;
  }
  if (config.verticals && config.verticals.length) {
    config.headers['x-cap-vertical-id'] = config.verticals[0];
  }
  config.headers['x-cap-api-data-context-org-id'] = orgID;
  if (process.env.NODE_ENV !== 'production' && token !== undefined) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}

export const get = (url, params, apiConfig) => {
  const config = getRequestConfig(apiConfig);
  config.params = params;
  const source = CancelToken.source();
  config.cancelToken = source.token;
  const request = axios.get(url, config);
  request[CANCEL] = () => source.cancel();
  return request;
};

export const post = (url, data, apiConfig) => {
  const config = getRequestConfig(apiConfig);
  const source = CancelToken.source();
  config.cancelToken = source.token;
  let postData = {};
  if (
    apiConfig &&
    apiConfig.headers &&
    apiConfig.headers['Content-Type'] &&
    apiConfig.headers['Content-Type'] !== 'application/json'
  ) {
    postData = data;
  } else {
    postData = JSON.stringify(data);
  }
  const request = axios.post(url, postData, config);
  request[CANCEL] = () => source.cancel();
  return request;
};

export const put = (url, data) => {
  const config = getRequestConfig();
  const source = CancelToken.source();
  config.cancelToken = source.token;
  config.headers['Content-Type'] = 'application/json';
  const request = axios.put(url, JSON.stringify(data), config);
  request[CANCEL] = () => source.cancel();
  return request;
};
